"use client";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import PropTypes from "prop-types";
import "./listitems.css";
/**
 * ListItems — renders object properties as list items.
 */
ListItems.propTypes = {
    /** Array of objects to render. */
    items: PropTypes.arrayOf(PropTypes.object).isRequired,
};
export function ListItems({ items }) {
    const listItems = items;
    return (_jsx("div", { className: "list-items", children: listItems.map((item, index) => (_jsxs("div", { className: "list-item", children: [_jsx("h2", { className: "list-item-title", children: String(item.title) }), _jsx("ul", { children: Object.entries(item)
                        .filter(([key]) => key !== "title")
                        .map(([key, value]) => (_jsxs("li", { children: [key, ":", " ", Array.isArray(value) && value.length > 1 ? (_jsx("ul", { children: value.map((item, valueIndex) => (_jsx("li", { children: String(item) }, `${String(item)}-${valueIndex}`))) })) : String(Array.isArray(value) ? value[0] ?? "" : value)] }, key))) })] }, `${String(item.title ?? "item")}-${index}`))) }));
}
